import React from 'react';
import {createRoot} from 'react-dom/client';
import MerklisteMenuButton from "./components/MerklisteMenuButton";

const rootElement = document.getElementById('like-toggle');
const root = createRoot(rootElement);

root.render(
    <MerklisteMenuButton />
);